<template>
  <catalog-category
    ref="child"
    :category="$route.query['header'] || 'all'"
    :selected-id="selectedId"
    :hide-header="!$route.query['header']"
    :hide-background="!$route.query['header']"
    @update-router-view-meta="v => routerViewMeta = v"
  />
</template>


<script>
import CatalogCategory from '@/views/CatalogCategory.vue';

export default {
  name: 'catalog',

  components: {
    CatalogCategory
  },

  props: [ 'selectedId' ],

  data() {
    return {
      routerViewMeta: {}
    };
  }
}
</script>
